import { createStore, AnyAction, Store } from 'redux';
import { createWrapper, Context, HYDRATE } from 'next-redux-wrapper';
import reducer, { IGlobalState } from './reducer';

const store = createStore(reducer);

export default store;
